import React, { useEffect, useState } from 'react';
import Navigation from '@/components/Navigation';
import HeroSection from '@/components/HeroSection';
import AboutSection from '@/components/AboutSection';
import NewChapterSection from '@/components/NewChapterSection';
import CareServicesSection from '@/components/CareServicesSection';
import ValuesSection from '@/components/ValuesSection';
import CQCSection from '@/components/CQCSection';
import FacilitiesSection from '@/components/FacilitiesSection';
import FoodSection from '@/components/FoodSection';
import ActivitiesSection from '@/components/ActivitiesSection';
import TestimonialsSection from '@/components/TestimonialsSection';
import KeyFactsSection from '@/components/KeyFactsSection';
import AvailabilitySection from '@/components/AvailabilitySection';
import FeesSection from '@/components/FeesSection';
import CareersSection from '@/components/CareersSection';
import TeamSection from '@/components/TeamSection';
import FAQSection from '@/components/FAQSection';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';
import BedAvailabilityPopup from '@/components/BedAvailabilityPopup';

const HomePage = () => {
  const [activeSection, setActiveSection] = useState('hero');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            setActiveSection(entry.target.id);
          }
        });
      },
      { threshold: 0.1, rootMargin: '-50px' }
    );

    const sections = document.querySelectorAll('section');
    sections.forEach((section) => observer.observe(section));

    return () => {
      sections.forEach((section) => observer.unobserve(section));
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      <Navigation activeSection={activeSection} />
      <main>
        <HeroSection />
        <AboutSection />
        <NewChapterSection />
        <CareServicesSection />
        <ValuesSection />
        <CQCSection />
        <FacilitiesSection />
        <FoodSection />
        <ActivitiesSection />
        <TestimonialsSection />
        <KeyFactsSection />
        <AvailabilitySection />
        <FeesSection />
        <CareersSection />
        <TeamSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
      <BedAvailabilityPopup />
    </div>
  );
};

export default HomePage;
